/**
 * Every key this app writes to localStorage, in one place so they can't collide
 * and so it's possible to see what we persist without grepping the codebase.
 */
export const LocalStorageKeys = Object.freeze({
  build: {
    /** Epoch ms until which the "new version available" prompt stays dismissed. */
    promptDismissedUntil: 'apx:build-prompt-dismissed-until',
  },
  session: {
    /**
     * Cross-tab session signalling. Written purely to fire a `storage` event in
     * the app's *other* tabs, which is what lets one tab's logout or re-login
     * settle the others. Not read back as state.
     */
    crossTabSync: 'apx:session-sync',
  },
} as const);
